import Tray from '@jetbrains/ring-ui/components/header/tray'
import * as React from 'react'

import {PlaceIdList} from '../../../pluginSystem/pluginSystem.types'
import Plugin from '../../common/Plugin/Plugin'
import {
  isMuteInvestigateButtonEnabled,
  isPipelinesEnabledInExclusiveMode,
} from '../../pages/PipelinesPages/utils/featureToggles'

import HeaderTrayHelp from './HeaderTrayHelp/HeaderTrayHelp'
import HeaderUser from './HeaderUser/HeaderUser'
import InvestigationsCounter from './InvestigationsCounter/InvestigationsCounter'

import styles from './Header.css'

function HeaderTray() {
  return (
    <Tray className={styles.tray}>
      <Plugin placeId={PlaceIdList.SAKURA_HEADER_USERNAME_BEFORE} />
      {(!isPipelinesEnabledInExclusiveMode() || isMuteInvestigateButtonEnabled) && (
        <InvestigationsCounter />
      )}
      <HeaderTrayHelp />
      <Plugin placeId={PlaceIdList.SAKURA_HEADER_RIGHT} />
      <HeaderUser />
    </Tray>
  )
}

export default React.memo(HeaderTray)
